import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLobbyJoinController } from '../controllers/useLobbyJoinController.js';

function LobbyJoin() {
    const {
        name, setName,
        lobbyCode, setLobbyCode,
        password, setPassword,
        error,
        handleSubmit,
        isPrivate
    } = useLobbyJoinController();

    const navigate = useNavigate();

    return (
        <div className="container">
            <div className="box">
                <div className="page-icon-header">
                    <div className="page-icon page-icon--join">
                        <i className="fas fa-right-to-bracket" />
                    </div>
                </div>
                <h2>Lobby beitreten</h2>
                <div className="page-divider">
                    <span className="page-divider-line" />
                    <span className="page-divider-diamond" />
                    <span className="page-divider-line" />
                </div>

                {error && <p style={{ color: '#ff416c', fontSize: '0.9rem', marginBottom: '1rem' }}>{error}</p>}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="name">Dein Name</label>
                        <input
                            type="text"
                            id="name"
                            placeholder="Spielername eingeben"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            maxLength={20}
                            autoFocus
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="code">Lobby-Code</label>
                        <input
                            type="text"
                            id="code"
                            placeholder="Z.B. AB12C"
                            value={lobbyCode}
                            onChange={(e) => setLobbyCode(e.target.value.toUpperCase())}
                            maxLength={5}
                        />
                    </div>

                    {isPrivate && (
                        <div className="form-group">
                            <label htmlFor="password">Passwort</label>
                            <input
                                type="password"
                                id="password"
                                placeholder="Lobby-Passwort"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                    )}

                    <div className="button-group">
                        <button type="submit" className="button button-primary">
                            <i className="fas fa-right-to-bracket" /> Beitreten
                        </button>
                        <button type="button" className="button button-secondary" onClick={() => navigate('/')}>
                            <i className="fas fa-arrow-left" /> Zurück
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default LobbyJoin;